export const SIGN_IN_FIELDS = {
  email: 'email',
  password: 'password',
} as const;

export type FormValues = {
  [SIGN_IN_FIELDS.email]: string;
  [SIGN_IN_FIELDS.password]: string;
};
